import React, { CSSProperties } from "react";
import { OutlinedInputProps } from "@mui/material/OutlinedInput";
import { useController } from "react-hook-form";
import { useSmartFormContext } from "components/SmartForm";
import { cvar } from "styles";
import { CalendarIcon } from "components/Icons";
import { InputAdornment } from "@mui/material";
import * as S from "./styles";

type SmartFormTextFieldT = {
  label?: string;
  name: string;
  helperText?: string | undefined;
  error?: boolean;
  disabled?: boolean;
  labelStyle?: CSSProperties;
  icon?: React.ReactNode;
} & OutlinedInputProps;

const CalendarInput = ({
  label,
  name,
  disabled = false,
  labelStyle = {},
  value,
  defaultValue,
  icon,
  ...rest
}: SmartFormTextFieldT) => {
  const { controllerProps } = useSmartFormContext();
  const { field } = useController({ ...controllerProps, name });
  return (
    <>
      <S.LabelGroupWrapper>
        <S.StyledFormLabel style={labelStyle}>{label}</S.StyledFormLabel>
      </S.LabelGroupWrapper>
      <S.StyledInput
        fullWidth
        inputProps={{
          style: {
            color: cvar("dark-blue"),
            fontSize: "14px",
            fontWeight: "500",
            padding: "7px 14px 8px",
            lineHeight: "17px",
            height: "17px",
          },
        }}
        disabled={disabled}
        size="small"
        defaultValue={defaultValue}
        sx={{ backgroundColor: disabled ? cvar("cotton-boll") : "white", borderRadius: "4px" }}
        {...field}
        {...rest}
        value={value}
        endAdornment={<InputAdornment position="end">{icon ?? <CalendarIcon />}</InputAdornment>}
      />
    </>
  );
};

export default CalendarInput;
